import { api } from "./api";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const ensureHead = (tag, attrs) => {
  const sel = `${tag}[${Object.entries(attrs).slice(0, 1).map(([k, v]) => `${k}="${v}"`)}]`;
  if (document.head.querySelector(sel)) return;
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
};

// Makes the admin installable (manifest + iOS meta) and registers the service worker.
export const setupAdminApp = () => {
  ensureHead("link", { rel: "manifest", href: "/admin.webmanifest" });
  ensureHead("link", { rel: "apple-touch-icon", href: "/admin-apple-touch-icon.png" });
  ensureHead("meta", { name: "apple-mobile-web-app-capable", content: "yes" });
  ensureHead("meta", { name: "mobile-web-app-capable", content: "yes" });
  ensureHead("meta", { name: "apple-mobile-web-app-title", content: "StripWise" });
  ensureHead("meta", { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" });
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
  if (!window.__swInstallHooked) {
    window.__swInstallHooked = true;
    window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__swInstall = e; window.dispatchEvent(new Event("sw-installable")); });
  }
};

const toKey = (b64) => {
  const s = (b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
};

export const currentSub = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  return reg ? reg.pushManager.getSubscription() : null;
};

export const enablePush = async () => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications were blocked. Allow them in your phone or browser settings.");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/admin/push/key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.public_key) }));
  const j = sub.toJSON();
  await api.post("/admin/push/subscribe", { endpoint: j.endpoint, keys: j.keys, device: navigator.userAgent });
  return sub;
};

export const disablePush = async () => {
  const sub = await currentSub();
  if (!sub) return;
  await api.post("/admin/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
};
